import React from 'react'
import { createRootRoute, Outlet } from '@tanstack/react-router'
import { createConnectTransport } from '@connectrpc/connect-web'
import { TransportProvider } from '@connectrpc/connect-query'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { authenticator } from '../components/pages/_shared/authService'
import { theme } from '../theme'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { Toaster } from 'sonner'

declare var IRDB_BACKEND_API_URL: string | undefined // eslint-disable-line no-var
const backendApiUrl = IRDB_BACKEND_API_URL
if (!backendApiUrl) {
  throw new Error('The IRDB_BACKEND_API_URL environment variable is not set')
}

const finalTransport = createConnectTransport({
  baseUrl: backendApiUrl,
  interceptors: [authenticator],
})
const queryClient = new QueryClient()

export const Route = createRootRoute({
  validateSearch: (search: Record<string, unknown>): { aiChatSessionId?: string } => {
    return {
      aiChatSessionId: typeof search.aiChatSessionId === 'string' ? search.aiChatSessionId : undefined,
    }
  },
  component: () => (
    <React.StrictMode>
      <TransportProvider transport={finalTransport}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Toaster richColors />
            <Outlet />
            <TanStackRouterDevtools />
          </ThemeProvider>
        </QueryClientProvider>
      </TransportProvider>
    </React.StrictMode>
  ),
})
